module App.Interfaces {
    export interface IWebsiteColor {
        color: string;
        textColor: string;
        headerLogoUrl: string;
        headerImageUrl: string;
        bannerImageUrl: string;
    }
}